import { registerDefaultsForModule } from '@glu/theming';
import legacy from './themes/legacyTheme';
import ash from './themes/ashTheme';

registerDefaultsForModule(
  'formComponents', ({ name, palette, typography }) => {
    const commonTheme = {
      error: {
        borderColor: palette.form.error,
        color: palette.form.error,
        fontFamily: typography.fontFamily,
        fontSize: 12,
        fontWeight: 'normal'
      },
      warning: {
        borderColor: palette.error,
        color: palette.error
      }
    };

    switch (name) {
      case 'ash':
        return {
          ...commonTheme,
          ...ash({ palette, typography })
        };
      default:
        return {
          ...commonTheme,
          ...legacy({ palette, typography })
        };
    }
  }
);
